import { Component, Input } from '@angular/core';

import { Landscape } from 'app/modules/browse/models/landscape';
import { WorldRegion } from 'app/modules/browse/models/world-region';
import { CarouselItems } from 'app/modules/browse/models/carousel-items.enum';
import { SimpleCardComponent } from '../../cards/simple-card/simple-card.component';
import { HorizontalScrollerComponent } from '../../horizontal-scroller/horizontal-scroller.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-double-carousel',
  templateUrl: './double-carousel.component.html',
  styleUrls: ['./double-carousel.component.scss'],
  standalone: true,
  imports: [HorizontalScrollerComponent, SimpleCardComponent, RouterLink],
})
export class DoubleCarouselComponent {
  @Input() landscapes: Landscape[] = [];
  @Input() regions: WorldRegion[] = [];

  CarouselItems: typeof CarouselItems = CarouselItems;
}
